import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoPipe } from '@jsverse/transloco';
import { LoadingIndicatorDirective } from '@zero/shared/ui-directives';
import { UserNotesComponent } from '@zero/shared/ui-web-components';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';
import { MultiOrderInstrument, TradeFacade } from '@zero/trade/domain';
import { filter } from 'rxjs';
import { MultiOrderCreateBuyListComponent } from '../multi-order-create-buy-list/multi-order-create-buy-list.component';
import { MultiOrderCreateSellListComponent } from '../multi-order-create-sell-list/multi-order-create-sell-list.component';
import { MultiOrderErrorComponent } from '../multi-order-error/multi-order-error.component';
import { MultiOrderSummaryComponent } from '../multi-order-summary/multi-order-summary.component';

@Component({
  selector: 'trade-multi-order-create',
  imports: [
    TranslocoPipe,
    UserNotesComponent,
    MultiOrderCreateBuyListComponent,
    MultiOrderCreateSellListComponent,
    MultiOrderSummaryComponent,
    AsyncPipe,
    LoadingIndicatorDirective,
    MultiOrderErrorComponent,
    ButtonComponent,
  ],
  templateUrl: './multi-order-create.component.html',
  styleUrl: './multi-order-create.component.scss',
})
export class MultiOrderCreateComponent implements OnInit {
  @Input() public instruments: MultiOrderInstrument[];

  @Output() public goNext = new EventEmitter<void>();

  public readonly facade = inject(TradeFacade);
  readonly #destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.facade.validateSuccess$
      .pipe(
        filter((isSuccessfullyVerified) => !!isSuccessfullyVerified),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe(() => this.goNext.emit());
  }
}
